import { useQuery } from '@tanstack/react-query';
import ManagedIntegrationTemplateList from 'types/temporaryManualTypes/ManagedIntegrationTemplateList.interface';

import managedIntegrationsService from 'services/managedIntegrationsService';

export type UseTemplateListQueryParams = {
  pageSize?: number;
};

export const useTemplateQuery = (
  queryParams: UseTemplateListQueryParams = {},
) =>
  useQuery<ManagedIntegrationTemplateList>(
    ['integration-template'],
    () =>
      managedIntegrationsService.managedIntegrationTemplate.list(queryParams),
    {
      refetchOnWindowFocus: false,
      retry: false,
      onError: (error) =>
        console.error('Failed to fetch Integration Templates', error),
    },
  );
